import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';

// Define sources array
const sources = [
  { icon: "🔥", label: "Firewalls" },
  { icon: "🛡️", label: "EDR/XDR" },
  { icon: "☁️", label: "Cloud" },
  { icon: "📊", label: "SIEM Agents" },
  { icon: "💻", label: "Applications" },
  { icon: "🌐", label: "Network" },
  { icon: "🔐", label: "Identity" },
  { icon: "📧", label: "Email" },
];

const LiveEventPath2Chronicle = () => {
    // Generate initial random events
    const randomEvents = Array.from({ length: 12 }, (_, i) => ({
      id: 1000 + i,
      source: sources[Math.floor(Math.random() * sources.length)].label,
      topic: `topic-${Math.floor(Math.random() * 10) + 1}`,
      event: [
        'Login Success',
        'Blocked IP',
        'Threat Detected',
        'Policy Update',
        'Data Exfiltration',
        'User Added',
        'Alert Cleared',
        'Malware Quarantined',
        'Config Change',
        'Suspicious Activity',
      ][Math.floor(Math.random() * 10)],
      time: `${Math.floor(Math.random() * 59) + 1} sec ago`,
      size: `${(Math.random() * 10 + 1).toFixed(2)} MB`,
    }));

    const [events, setEvents] = useState(randomEvents);

    // Simulate new events
      useEffect(() => {
        const interval = setInterval(() => {
          setEvents(evts => {
            const newEvt = {
              id: Math.floor(Math.random() * 10000),
              source: sources[Math.floor(Math.random() * sources.length)].label,
              topic: `topic-${Math.floor(Math.random() * 10) + 1}`,
              event: [
                'Login Success',
                'Blocked IP',
                'Threat Detected',
                'Policy Update',
                'Data Exfiltration',
                'User Added',
                'Alert Cleared',
                'Malware Quarantined',
                'Config Change',
                'Suspicious Activity',
              ][Math.floor(Math.random() * 10)],
              time: `${Math.floor(Math.random() * 59) + 1} sec ago`,
              size: `${(Math.random() * 10 + 1).toFixed(2)} MB`,
            };
            return [newEvt, ...evts].slice(0, 20);
          });
        }, 3500);
        return () => clearInterval(interval);
      }, []);

  return (
    <>
        <CardContent sx={{ maxHeight: 620, overflowY: 'auto', p: 2, pb: 4 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#60a5fa' }}>Recent Events</Typography>
              <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
              {/* Header Row */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, fontWeight: 700, color: '#b0bec5', mb: 1, position: 'sticky', top: 0, background: 'rgba(10,34,64,0.92)', zIndex: 2, py: 1 }}>
                <Typography variant="caption" sx={{ minWidth: 60 }}>ID</Typography>
                <Typography variant="caption" sx={{ minWidth: 90 }}>Source</Typography>
                <Typography variant="caption" sx={{ minWidth: 80 }}>Topic</Typography>
                <Typography variant="caption" sx={{ flex: 1 }}>Event</Typography>
                <Typography variant="caption" sx={{ minWidth: 80 }}>Time</Typography>
                <Typography variant="caption" sx={{ minWidth: 70, textAlign: 'right' }}>Size</Typography>
              </Box>
              {events.length === 0 ? (
                <Typography variant="body2" sx={{ color: '#b0bec5', textAlign: 'center', mt: 4 }}>
                  No events to display.
                </Typography>
              ) : (
                events.map((row, i) => (
                  <Box key={row.id} sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="caption" sx={{ color: '#b0bec5', minWidth: 60, fontWeight: 700 }}>#{row.id}</Typography>
                    <Typography variant="body2" sx={{ color: '#60a5fa', minWidth: 90 }}>{row.source}</Typography>
                    <Typography variant="body2" sx={{ color: '#ab47bc', minWidth: 80 }}>{row.topic}</Typography>
                    <Typography variant="body2" sx={{ flex: 1, color: 'white', fontWeight: 500 }}>{row.event}</Typography>
                    <Typography variant="caption" sx={{ color: '#b0bec5', minWidth: 80 }}>{row.time}</Typography>
                    <Typography variant="caption" sx={{ color: '#ffa726', minWidth: 70, textAlign: 'right' }}>{row.size}</Typography>
                  </Box>
                ))
              )}
        </CardContent>
    </>
  )
}

export default LiveEventPath2Chronicle